import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/planning/")({
  loader: ({ params }) => {
    throw redirect({
      to: "/$locale/{-$schoolyear}/$school/planning/year",
      params: { locale: params.locale, schoolyear: params.schoolyear, school: params.school },
    });
  },
});
